module.exports = __webpack_public_path__ + "static/media/new_cat_pack_EN_285x350.785d486f.png";